import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider, addLocaleData } from 'react-intl'
import { numberOfTrips } from '../actions/search-actions'
import { selectedCurrency, setCurrency, pageLoader, itineraryPopupOpen, itineraryPopupData } from '../actions/main-actions'
import { currencyDirective, collectionDescriptionMargin, toggleDestinations, convertDjangoRenderedPrice } from '../directives'
import ErrorHandler from '../components/ErrorHandler'

// import * as fx from '../libs/money'
import { getLanguage } from '../utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'

import en from 'react-intl/locale-data/en.js'
import fr from 'react-intl/locale-data/fr.js'
import de from 'react-intl/locale-data/de.js'
import it from 'react-intl/locale-data/it.js'
import es from 'react-intl/locale-data/es.js'
import HeroSearch from '../components/homepage/Hero'
import PreviousSearch from '../components/homepage/PreviousSearch'
import HomepageCollections from '../components/homepage/HomepageCollections'
import SpecialDeals from '../components/homepage/SpecialDeals'
import IndividualBooking from '../components/footer/IndividualBooking'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: ['AbortError', 'UnhandledRejection', 'Unexpected token o in JSON at position 1', 'Anonymous function(/gtm.js)'],
  })
}

addLocaleData([...en, ...fr, ...de, ...it, ...es])

let store = createStore(combineReducers({
  pageLoader,
  numberOfTrips,
  selectedCurrency,
  itineraryPopupOpen,
  itineraryPopupData,
}))

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  Promise.all([
    window.fetch(window.staticPath + `travel-app/dist/translations/travel-${language}.json`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      } }),
  ]).then(function([ response ]) {
    response.json().then((msg) => {
      messages = msg[`travel-${language}`]

      renderApp()
    })
  })
} else {
  renderApp()
}

function renderApp() {
  renderElement('homepage-hero-search', HeroSearch, { searchLaUrl: window.searchLaUrl })
  renderElement('homepage-previous-search', PreviousSearch)
  renderElement('homepage-collections', HomepageCollections)
  renderElement('homepage-special-deals', SpecialDeals)
  renderElement('email-us', IndividualBooking)
  toggleDestinations()
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  convertDjangoRenderedPrice(renderElement)
  collectionDescriptionMargin()
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    ReactDOM.render(
      <IntlProvider locale={language === 'ach' ? 'en' : language} messages={messages}>
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
      element
    )
  }
}
